import { IChangePasswordResponse } from "../../utils/types";
import { apiManager } from "../api-manager";

export const changePassword = async (oldPassword: string, password: string) => {
  let res = await apiManager.post<IChangePasswordResponse>(
    "/auth/admin/change-password",
    {
      oldPassword,
      password,
    }
  );
  return res;
};
